import clsx from 'clsx';
import {Field, ErrorMessage} from 'formik';

import TextError from './TextError';

function Select(props: any) {
  const {label, name, options, labelOf = false, ...rest} = props;
  return (
    <div className='row mb-7'>
      {!labelOf && (
        <label className='col-form-label fw-bold fs-6' htmlFor={name}>
          <span className={clsx(props.required && 'required')}> {label}</span>
        </label>
      )}
      <div className={clsx(['mb-3 mb-lg-0'])}>
        <Field
          as='select'
          id={name}
          name={name}
          {...rest}
          className='form-select form-select-solid form-select-lg fw-bold'
          aria-label={label}
        >
          {options.map((option: any) => {
            return (
              <option key={option.value} value={option.value}>
                {option.key}
              </option>
            );
          })}
        </Field>
      </div>
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
}

export default Select;
